/**
 * Copyright IBM Corp. 2022, 2026
 */

import ModularContent from 'components/ModularContent'
import s from './style.module.css'

export default function LegacyContent({ description, content }) {
	return (
		<div
			className={`${s.legacyContent} legacy-resource-content`}
			data-cy="resource-legacy-content"
		>
			{description ? <p className="g-type-body-large">{description}</p> : null}
			{content.map((item) => (
				<ModularContent
					key={`${item.__typename}-${item.id}`} // Prevent potential regression by aligning on existing key strategy
					section={item}
					needDistinctIds
				/>
			))}
		</div>
	)
}
